export default "__VITE_ASSET__4G4lwxFN__"